import React, { useEffect, useState } from "react";
import Header from "../components/Header";
import Button from "react-bootstrap/Button";
import Sidebar from "../components/Sidebar";
import Box from "@mui/material/Box";
import { DataGrid } from "@mui/x-data-grid";
import Modal from "react-bootstrap/Modal";
import { Form, Formik, Field, ErrorMessage } from "formik";
import { Store } from "react-notifications-component";
import * as Yup from "yup";
import FileInput from "../components/FileInput.js";
import { useTheme } from "@mui/material/styles";
import {
  MyTextArea,
  MyTextInput,
} from "../services/authentication/inputServices.js";

import {
  getJourneyDetails,
  getTagDetails,
  CreatePlaces,
  get_journey_data,
  delete_place,
  update_place_byId,
  delete_place_image,
  getAllPlaces,
} from "../services/web/webServices";

import GooglePlacesAutocomplete, {
  geocodeByAddress,
  getLatLng,
} from "react-google-places-autocomplete";
import Loader from "../components/Helpper/Loader.js";
import GoogleMapSelector from "../components/GoogleMapSelector.js";
import GoogleMapSelectorEdit from "../components/GoogleMapSelecterEdit.js";

function PlacesManagements() {

  const theme = useTheme();
  const [openSidebarToggle, setOpenSidebarToggle] = useState(false);
  const [show, setShow] = useState(false);
  const handleShow = () => setShow(true);
  const [showEye, setShowEye] = useState(false);
  const [placesRowData, setPlacesRowData] = useState([]);
  const [showEdit, setShowEdit] = useState(false);
  const [updatePlaceId, setUpdatePlaceId] = useState(null);
  const [showImages, setShowImages] = useState(false);
  const [galleryImage, setGalleryImage] = useState([]);
  const [isPhotos, setIsPhotos] = useState(false);
  const [isAudio, setIsAudio] = useState(false);
  const [isChurch, setIsChurch] = useState(false);

  const OpenSidebar = () => {
    setOpenSidebarToggle(!openSidebarToggle);
  };

  const handleClose = () => {
    setShow(false);
    setBusinessImage2({ preview: "", raw: "" });
    setAddress("");
    setIsPhotos(false);
    setIsAudio(false);
    setIsChurch(false);
    setSelectedTagIds([]);
    setJourney("");
    seterrormessageselect("");
    seterrorjourney("");
    setIsAddressSelected(false);
  };

  const handleClose1 = () => {
    setShowEye(false);
    setIsPhotos(false);
    setIsAudio(false);
    setIsChurch(false);
    setSelectedTagIds([]);
    setJourney("");
    setBusinessImage2({ preview: "", raw: "" });
    setAddress("");
  };
  const handleShow1 = (params) => {
    setPlacesRowData(params);
    setShowEye(true);
    setJourney(params.row.journeyId)
  };

  const handleClose3 = () => {
    setBusinessImage2({ preview: "", raw: "" });
    setAddress("");
    setShowEdit(false);
    setIsPhotos(false);
    setIsAudio(false);
    setIsChurch(false);
    setSelectedTagIds([]);
    setJourney("");
    setIsAddressSelected(false);
  };

  const handleShow3 = (params) => {
    setUpdatePlaceId(params.row.id);
    setPlacesRowData(params);
    setShowEdit(true);
    setJourney(params.row.journeyId)
    setLatLng({ lat: params.row.latitude, lng: params.row.longitude });
  };

  const handleClose4 = () => setShowImages(false);

  const handleShow4 = (params) => {
    // console.log(
    //   "111112-================================================================",
    //   params
    // );
    setGalleryImage(params);
    // console.log("paramssssssssssssssssssss", params);
    setShowImages(true);
  };

  const pageName = "Places Management";
  const onDelete = (params) => () => {
    if (window.confirm("Are you sure you want to delete the place?")) {
      delete_place(params.row.id)
        .then((res) => {
          Store.addNotification({
            title: "Success",
            message: res?.data?.message,
            type: "success",
            insert: "top",
            container: "top-right",
            animationIn: ["animate__animated", "animate__fadeIn"],
            animationOut: ["animate__animated", "animate__fadeOut"],
            dismiss: {
              duration: 3000,
              onScreen: true,
            },
          });

          get_journey_data(params.row.journeyId)
            .then((res) => {
              const places = Array.isArray(res?.data?.data) ? res.data.data : [];
              setJourneyDataById(
                places.map((el, index) => ({
                  ...el,
                  id: el._id,
                  i: index,
                }))
              );
            })

            .catch((err) => {
              console.log(err);
            });
          getAllPlaces()
            .then((res) => {
              const places = Array.isArray(res?.data?.data) ? res.data.data : [];
              setAllPlaces(places);
            })
            .catch((err) => {
              console.log(err);
            });
        })
        .catch((err) => {
          console.log(err);
        });

      if (journeyData !== "") {
        get_journey_data(journeyData)
          .then((res) => {
            // setUserDetail(res.data.user);
            const places = Array.isArray(res?.data?.data) ? res.data.data : [];
            setJourneyDataById(
              places.map((el, index) => ({
                ...el,
                id: el._id,
                i: index,
              }))
            );
          })

          .catch((err) => {
            console.log(err);
          });
      }
    }
  };
  const columns = [
    {
      field: "sno",
      headerName: "S.NO.",
      filterable: false,
      width: 100,
    },
    {
      field: "title",
      headerName: "Title",
      width: 200,
    },

    {
      field: "location",
      headerName: "Location",
      width: 300,
    },
    {
      field: "galleryimageurl",
      headerName: "Images",
      width: 150,
      renderCell: (params) => {
        return (
          <>
            <Button
              style={{
                backgroundColor: "#64A433",
                border: "none",
                marginRight: "5px",
              }}
              onClick={() => handleShow4(params)}
            >
              {/* <i className="fas fa-eye"></i> */}
              View
            </Button>
          </>
        );
      },
    },
    {
      field: "action",
      headerName: "Action",
      width: 210,

      renderCell: (params) => {
        return (
          <>
            <Button
              style={{
                backgroundColor: "#64A433",
                border: "none",
                marginRight: "5px",
              }}
              onClick={() => handleShow1(params)}
            >
              <i className="fas fa-eye"></i>
            </Button>

            <Button
              style={{
                backgroundColor: "#64A433",
                border: "none",
                marginRight: "5px",
              }}
              onClick={() => handleShow3(params)}
            >
              <i className="fas fa-edit"></i>
            </Button>

            <Button
              color="error"
              onClick={onDelete(params)}
              style={{ backgroundColor: "#64A433", border: "none" }}
            >
              <i className="fa fa-trash" aria-hidden="true"></i>
            </Button>
          </>
        );
      },
    },
  ];

  useEffect(() => {
    if (placesRowData?.row?.instructions) {
      setIsPhotos(placesRowData.row.instructions.isphotos);
      setIsAudio(placesRowData.row.instructions.isaudio);
      setIsChurch(placesRowData.row.instructions.ischurch);
    }
  }, [placesRowData]);

  useEffect(() => {
    if (placesRowData?.row?.tags) {
      setSelectedTagIds(placesRowData.row.tags);
    }
  }, [placesRowData]);

  const css = `
/* Style for form container */
.form-container {
  max-width: 800px;
  margin: auto;
  padding: 20px;  
  background-color: #f9f9f9;
  border: 1px solid #ddd;
  border-radius: 5px;
}

/* Style for form labels */
.form-label {
  margin-bottom: 5px;
  display: block;
  
  color: #555659; 
}
  .form-select2{
   padding: 10px;
  border: 1px solid #ccc;
  border-radius: 5px;
  }


.form-input,
.form-textarea,
.form-select {
  margin-right: 10px;
  margin-bottom: 10px;
  width: calc(100% - 20px); /* Adjust width based on your margins */
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 5px;
  box-sizing: border-box; /* Ensure padding is included in the width */
}

/* Style for checkboxes */
.form-checkboxes {
  margin-bottom: 10px;
}

/* Style for tag inputs */
.form-tag-inputs {
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 10px;
}

.form-tag-input {
  flex: 1;
  margin-right: 10px;
  margin-bottom: 10px;
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 5px;
}

/* Style for submit button */
.form-submit {
  padding: 10px 20px;
  background-color: #4CAF50;
  color: white;
  border: none;
  cursor: pointer;
  border-radius: 5px;
}

.form-submit:hover {
  background-color: #45a049;
}

/* Added form-row and form-group classes */
.form-row {
  display: flex;
  justify-content: space-between;
  margin-bottom: 10px;
}

.form-group {
  width: 78%; 
}
.form-group {
  margin-bottom: 20px;
}

.form-label {
  margin-bottom: 5px;
  display: block;
  font-weight: bold;
}

.form-input {
  margin-bottom: 10px;
  padding: 5px;

}

.image-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(150px, 1fr)); /* Responsive grid */
  gap: 10px;
}

.image-item {
  position: relative;
}

.preview-image {
  width: 100%;
  height: auto;
  display: block;
}

button {
  margin-top: 5px;
  padding: 5px 10px;
  background-color: #007bff;
  color: white;
  border: none;
  cursor: pointer;
}

button:hover {
  background-color: #0056b3;
}

button:active {
  background-color: #0056b3;
}

.checkbox-container {
  width: 300px; /* Adjust width as needed */
  height: 100px; /* Adjust height as needed */
  overflow-y: auto; /* Enable vertical scrollbar */
  border: 1px solid #ccc; /* Add border */
  border-radius: 5px; /* Optional: Add border radius */
  padding: 10px; /* Optional: Add padding */
}
.checkbox-wrapper {
  margin-bottom: 10px;
}

.checkbox-label {
  display: block;
  position: relative;
  padding-left: 35px;
  margin-bottom: 8px;
  cursor: pointer;
  font-size: 18px;
  user-select: none;
}

.checkbox-label input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;
}

.checkmark {
  position: absolute;
  top: 0;
  left: 0;
  height: 25px;
  width: 25px;
  background-color: #ccc;
  border-radius: 5px;
}

.checkbox-label:hover .checkmark {
  background-color: #bbb;
}

.checkbox-label input:checked ~ .checkmark {
  background-color: #2196F3;
}

.checkmark:after {
  content: "";
  position: absolute;
  display: none;
}

.checkbox-label input:checked ~ .checkmark:after {
  display: block;
}

.checkbox-label .checkmark:after {
  left: 9px;
  top: 5px;
  width: 6px;
  height: 12px;
  border: solid white;
  border-width: 0 2px 2px 0;
  transform: rotate(45deg);
}
  
.error-message {
  color: red;
  
}

  `;

  // ----------------------------------------------------

  const [address, setAddress] = useState("");
  const [isAddressSelected, setIsAddressSelected] = useState(false);
  const [Journey, setJourney] = useState("");
  const [journeyData, setJourneyData] = useState("");
  const [journeyDetail, setjourneyDetail] = useState([]);
  const [tagDetail, setTagDetal] = useState([]);
  const [selectedTagIds, setSelectedTagIds] = useState([]);
  const [latLng, setLatLng] = useState({});
  const [select, setSelection] = useState([]);
  const [getbutton, setbutton] = useState(false);
  const [getLoader, setLoader] = useState(true);
  const [errormessageselect, seterrormessageselect] = useState("");
  const [errorjourney, seterrorjourney] = useState("");
  const [businessImage2, setBusinessImage2] = useState({
    preview: "",
    raw: "",
  });

  console.log(latLng, 'lat long')

  useEffect(() => {
    getJourneyDetails()
      .then((res) => {
        const journeys = Array.isArray(res?.data?.data) ? res.data.data : [];
        const filteredData = journeys.filter(
          (item) => item.id !== "67778b3ddf3d2c30bc6aa0f0"
        );
        // If you intended to use filteredData, replace journeys with filteredData here.
        setjourneyDetail(journeys);
        if (journeyData == "") {
          // console.log("3333333333333", journeys[0]?.id);
          if (!journeys?.[0]?.id) return;
          get_journey_data(journeys[0].id)
            .then((res) => {
              const places = Array.isArray(res?.data?.data) ? res.data.data : [];
              setJourneyDataById(
                places.map((el, index) => ({
                  ...el,
                  id: el._id,
                  i: index,
                }))
              );
            })
            .catch((err) => {
              console.log(err);
            });
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  useEffect(() => {
    getTagDetails()
      .then((res) => {
        const tags = Array.isArray(res?.data?.data) ? res.data.data : [];
        setTagDetal(tags);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  const handleSelectAddress = (item, setFieldValue) => {
    setAddress(item.description);
    geocodeByAddress(item.description)
      .then((results) => getLatLng(results[0]))
      .then((location) => {
        setLatLng(location);

        // Save into Formik fields
        setFieldValue("latitude_manually", location.lat);
        setFieldValue("longitude_manually", location.lng);
      });
    setIsAddressSelected(true);
  };

  const handleJourney = (event) => {
    setJourney(event.target.value);
  };

  const handleTagChange = (event) => {
    const value = event.target.value;
    if (selectedTagIds.includes(value)) {
      setSelectedTagIds(selectedTagIds.filter((tagId) => tagId !== value));
    } else {
      setSelectedTagIds([...selectedTagIds, value]);
    }
  };

  const handleBusinessImage = (e) => {
    if (e.target.files.length) {
      setBusinessImage2({
        preview: URL.createObjectURL(e.target.files[0]),
        raw: e.target.files[0],
      });
    }
  };

  const handleGetJourney = (event) => {
    setJourneyData(event.target.value);
  };
  const [jorurneyDatabyId, setJourneyDataById] = useState([]);

  // console.log(
  //   "dataaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaa",
  //   jorurneyDatabyId
  // );

  useEffect(() => {
    if (journeyData !== "") {
      setLoader(true);
      get_journey_data(journeyData)
        .then((res) => {
          const places = Array.isArray(res?.data?.data) ? res.data.data : [];
          setJourneyDataById(
            places.map((el, index) => ({
              ...el,
              id: el._id,
              i: index,
            }))
          );
          setLoader(false);
        })
        .catch((err) => {
          setLoader(false);
          console.log(err);
        });
    } else {
      // If journey selection is cleared, rely on "all places" list
      setLoader(false);
    }
  }, [journeyData]);

  const [allPlaces, setAllPlaces] = useState([]);

  useEffect(() => {
    setLoader(true);
    getAllPlaces()
      .then((res) => {
        const places = Array.isArray(res?.data?.data) ? res.data.data : [];
        setAllPlaces(places);
        setLoader(false);
      })
      .catch((err) => {
        setLoader(false);
        console.log(err);
      });
  }, []);

  const onDeleteImage = (id, deletefor) => {
    if (window.confirm("Are you sure you want to delete this image")) {
      // console.log("imageiddddd", id);
      // console.log("2222222222222", galleryImage?.row?.id);
      // console.log("deleteforrrrrrrrrrrrr", deletefor);

      delete_place_image(galleryImage?.row?.id, id, deletefor)
        .then((res) => {
          Store.addNotification({
            title: "Success",
            message: res?.data?.message,
            type: "success",
            insert: "top",
            container: "top-right",
            animationIn: ["animate__animated", "animate__fadeIn"],
            animationOut: ["animate__animated", "animate__fadeOut"],
            dismiss: {
              duration: 3000,
              onScreen: true,
            },
          });

          get_journey_data(res?.data?.data?.journeyId)
            .then((res) => {
              const places = Array.isArray(res?.data?.data) ? res.data.data : [];
              setJourneyDataById(
                places.map((el, index) => ({
                  ...el,
                  id: el._id,
                  i: index,
                }))
              );
            })
            .catch((err) => {
              console.log(err);
            });
          getAllPlaces()
            .then((res) => {
              const places = Array.isArray(res?.data?.data) ? res.data.data : [];
              setAllPlaces(places);
            })
            .catch((err) => {
              console.log(err);
            });
          // setGalleryImage(res?.data?.data);
          // handleClose4();
        })
        .catch((err) => {
          console.log(err);
        });
    }
  };
  const allPlacesWithIndex = allPlaces.map((item, index) => ({
    ...item,
    sno: index + 1,
  }));

  const journeyDataWithIndex = jorurneyDatabyId.map((item, index) => ({
    ...item,
    sno: index + 1,
  }));

  const displayedRows = journeyData ? journeyDataWithIndex : allPlacesWithIndex;

  return (
    <>
      <style>{css}</style>
      <div className="grid-container">
        <Sidebar
          openSidebarToggle={openSidebarToggle}
          OpenSidebar={OpenSidebar}
        />
        <Header OpenSidebar={OpenSidebar} pageName={pageName} />
        <div
          style={{
            gridArea: "main",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            flexDirection: "column",
            margin: "0 90px 150px",
            marginTop: "30px",
            position: "relative",
            paddingBottom: "100px",
          }}
        >
          <div style={{ display: "flex", position: "relative" }}>
            <div
              className="form-group"

            >
              {/* <label className="form-label">Select Journey:</label> */}
              <select
                id="test"
                name="journey"
                type="text"
                className="form-select2"
                onChange={handleGetJourney}
                value={journeyData}
                defaultValue={journeyData}
                style={{ position: "relative", zIndex: "10", width: "200px" }}
              >
                {/* <option readOnly>Select</option> */}
                <option value="">Select Journey</option>
                {journeyDetail.map((journey) => (
                  <option key={journey.id} value={journey.id}>
                    {journey.title}
                  </option>
                ))}
              </select>
            </div>
            <div style={{ marginLeft: "200px" }}>
              <Button
                onClick={handleShow}
                style={{
                  backgroundColor: "#64A433",
                  border: "none",
                  marginTop: "30px",
                  width: "150px",
                }}
              >
                Add places +
              </Button>
            </div>
          </div>

          <div style={{ width: "100%" }}>
            <Box
              sx={{
                height: 500,
                width: "100%",
                boxShadow: 7,
                minWidth: "700px",
              }}
            >
              {getLoader ? (
                <Loader />
              ) : displayedRows.length > 0 ? (
                <>
                  <h2>{select.map((val) => val.id)}</h2>
                  <DataGrid
                    rows={displayedRows}
                    columns={columns}
                    initialState={{
                      pagination: {
                        paginationModel: { page: 0, pageSize: 10 },
                      },
                    }}
                    pageSizeOptions={[5, 10, 25]}
                    // xw
                    onSelectionChange={(newSelection) => {
                      setSelection(newSelection.rows);

                    }}
                    sx={{
                      "& .MuiDataGrid-row:nth-of-type(odd)": {
                        backgroundColor: theme.palette.action.hover, // Light grey background
                      },
                      "& .MuiDataGrid-cell:last-child": {
                        border: 0, // Hide the last cell border
                      },
                    }}
                  />
                </>
              ) : (
                <p style={{ fontSize: "30px", padding: "30px" }}>
                  No data found.
                </p>
              )}
            </Box>
          </div>
        </div>

        <Modal show={show} onHide={handleClose} size="lg">
          <Modal.Header closeButton>
            <Modal.Title>Add Places </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Formik
              initialValues={{
                title: "",
                title_sp: "",
                description: "",
                description_sp: "",
                imageurl: null,
                galleryimageurl: null,
                panoramicImageUrl: null,
                aerialViewImageUrl: null,
                estimatedTimeToVisit: "",
                description_podcast: "",
                description_podcast_sp: "",
                latitude_manually: "",
                longitude_manually: "",
              }}
              validationSchema={Yup.object({
                title: Yup.string()
                  .required("Title is required")
                  .min(3, "Title must be at least 3 characters")
                  .max(50, "Title cannot exceed 50 characters"),

                title_sp: Yup.string()
                  .required("Title in Spanish is required")
                  .min(3, "Title must be at least 3 characters")
                  .max(50, "Title cannot exceed 50 characters"),
                description: Yup.string()
                  .required("Please Enter Description")
                  .min(10, "Description must be at least 10 characters"),

                description_sp: Yup.string()
                  .required("Please Enter Description in Spanish")
                  .min(10, "Description must be at least 10 characters"),
                latitude_manually: Yup.string(),
                longitude_manually: Yup.string(),
                description_podcast: Yup.string()
                  .required("Description for podcast is required")
                  .min(10, "Description must be at least 10 characters"),

                description_podcast_sp: Yup.string()
                  .required("Description for podcast in Spanish is required")
                  .min(10, "Description must be at least 10 characters"),
                imageurl: Yup.mixed().required("Please select cover image"),
                panoramicImageUrl: Yup.array()
                  .min(1, "Please upload at least one image")
                  .required("Please select images")
                  .of(Yup.mixed().required("Please select images")),
                galleryimageurl: Yup.array()
                  .min(1, "Please upload at least one image")
                  .required("Please select images")
                  .of(Yup.mixed().required("Please select images")),
                aerialViewImageUrl: Yup.array()
                  .min(1, "Please upload at least one image")
                  .required("Please select images")
                  .of(Yup.mixed().required("Please select images")),
                estimatedTimeToVisit: Yup.number()
                  // .nullable()
                  .positive("Time must be a positive number")
                  .integer("Time must be an integer")
                  .required("Please enter estimated time"),
                // .optional(), // Validation for the estimatedTimeToVisit field
              })}
              onSubmit={(values, { resetForm }) => {
                if (selectedTagIds.length == 0) {
                  seterrormessageselect("Please select atleast one Tag");
                  if (Journey == "") {
                    seterrorjourney("Please select journey");
                  }
                  return;
                } else {
                  seterrormessageselect("");
                  if (Journey == "") {
                    seterrorjourney("Please select journey");
                    return;
                  } else {
                    seterrorjourney("");
                  }
                }
                if (!address) {
                  Store.addNotification({
                    title: "Validation Error",
                    message: "Please select place from dropdown",
                    type: "danger",
                    insert: "top",
                    container: "top-right",
                    animationIn: ["animate__animated", "animate__fadeIn"],
                    animationOut: ["animate__animated", "animate__fadeOut"],
                    dismiss: {
                      duration: 3000,
                      onScreen: true,
                    },
                  });
                  return;
                }
                // console.log("values", values);
                let formData = new FormData();
                debugger
                formData.append("title", values.title);
                formData.append("title_sp", values.title_sp);
                formData.append("description", values.description);
                formData.append("description_sp", values.description_sp);
                formData.append("latitude_manually", values.latitude_manually);
                formData.append(
                  "longitude_manually",
                  values.longitude_manually
                );

                formData.append(
                  "description_podcast",
                  values.description_podcast
                );
                formData.append(
                  "description_podcast_sp",
                  values.description_podcast_sp
                );
                // formData.append("imageurl", businessImage2.raw);

                formData.append("location", address);
                formData.append("latitude", latLng.lat);
                formData.append("longitude", latLng.lng);
                formData.append("journeyId", Journey);

                selectedTagIds.forEach((tagId, index) => {
                  formData.append(`tags[${index}]`, tagId);
                });

                formData.append("isphotos", isPhotos);
                formData.append("isaudio", isAudio);
                formData.append("ischurch", isChurch);

                if (values.estimatedTimeToVisit) {
                  formData.append(
                    "estimatedTimeToVisit",
                    values.estimatedTimeToVisit
                  );
                }

                formData.append("imageurl", values.imageurl[0]);

                Array.from(values.galleryimageurl).forEach((file, index) => {
                  formData.append(`galleryimageurl`, file);
                });
                Array.from(values.panoramicImageUrl).forEach((file, index) => {
                  formData.append(`panoramicImageUrl`, file);
                });
                Array.from(values.aerialViewImageUrl).forEach((file, index) => {
                  formData.append(`aerialViewImageUrl`, file);
                });

                setbutton(true);
                CreatePlaces(formData)
                  .then((res) => {
                    Store.addNotification({
                      title: "Success",
                      message: res?.data?.message,
                      type: "success",
                      insert: "top",
                      container: "top-right",
                      animationIn: ["animate__animated", "animate__fadeIn"],
                      animationOut: ["animate__animated", "animate__fadeOut"],
                      dismiss: {
                        duration: 3000,
                        onScreen: true,
                      },
                    });
                    resetForm({ formData: "" });
                    setbutton(false);
                    handleClose();
                    setJourneyData(Journey);
                    get_journey_data(Journey)
                      .then((res) => {
                        const places = Array.isArray(res?.data?.data) ? res.data.data : [];
                        setJourneyDataById(
                          places.map((el, index) => ({
                            ...el,
                            id: el._id,
                            i: index,
                          }))
                        );
                      })

                      .catch((err) => {
                        console.log(err);
                      });

                    getAllPlaces()
                      .then((res) => {
                        const places = Array.isArray(res?.data?.data) ? res.data.data : [];
                        setAllPlaces(places);
                      })
                      .catch((err) => {
                        console.log(err);
                      });
                  })
                  .catch((err) => {
                    if (err) {
                      Store.addNotification({
                        title: "Error!",
                        message: err?.response?.data?.message,
                        type: "danger",
                        insert: "top",
                        container: "top-right",
                        animationIn: ["animate__animated", "animate__fadeIn"],
                        animationOut: ["animate__animated", "animate__fadeOut"],
                        dismiss: {
                          duration: 3000,
                          onScreen: true,
                        },
                      });
                      setbutton(false);
                    }
                  });
              }}
            >
              {({ setFieldValue }) => (
                <div className="form-container">
                  <Form>
                    <div className="form-row">
                      <div className="form-group">
                        <label className="form-label">Title:</label>
                        <MyTextInput
                          type="text"
                          name="title"
                          className="form-input"
                        />
                      </div>
                      <div className="form-group">
                        <label className="form-label">Title in Spanish:</label>
                        <MyTextInput
                          type="text"
                          name="title_sp"
                          className="form-input"
                        />
                      </div>
                    </div>
                    <div className="form-row">
                      <div className="form-group">
                        <label className="form-label">Description:</label>
                        <MyTextArea
                          type="text"
                          name="description"
                          // required
                          className="form-textarea"
                        />
                      </div>
                      <div className="form-group">
                        <label className="form-label">
                          Description in Spanish:
                        </label>
                        <MyTextArea
                          type="text"
                          name="description_sp"
                          // required
                          className="form-textarea"
                        />
                      </div>
                    </div>
                    <div className="form-row">
                      <div className="form-group">
                        <label className="form-label">Podcast Description:</label>
                        <MyTextArea
                          type="text"
                          name="description_podcast"
                          // required
                          className="form-textarea"
                        />
                      </div>
                      <div className="form-group">
                        <label className="form-label">
                          Podcast Description in Spanish:
                        </label>
                        <MyTextArea
                          type="text"
                          name="description_podcast_sp"
                          // required
                          className="form-textarea"
                        />
                      </div>
                    </div>
                    <div className="form-row">
                      <div className="form-group">
                        <label htmlFor="imageurl" className="form-label">
                          Cover Image
                        </label>
                        <Field
                          name="imageurl"
                          accept="image/*"
                          component={FileInput}
                        />
                        <ErrorMessage
                          name="imageurl"
                          component="div"
                          className="error-message"
                        />
                      </div>
                      {/* <div className="form-group">
                        <label className="form-label">Address</label>

                        <GooglePlacesAutocomplete
                          apiKey="AIzaSyC82fZSJymdGrJnap27r0enC7nQahR3E8Q"
                          onSelect={(item) => handleSelectAddress(item, setFieldValue)}
                          renderInput={(props) => (
                            <input
                              {...props}
                              className="form-control"
                              style={{ backgroundColor: "white" }}
                              required
                            ></input>
                          )}
                        />
                      </div> */}


                    </div>
                    <div>
                      <div className="form-group">
                        <label>Select Location on Map</label>
                        <GoogleMapSelector setLatLng={setLatLng} setAddress={setAddress} setFieldValue={setFieldValue} />
                      </div>
                    </div>
                    <div className="form-row">
                      <div className="form-group">
                        <label className="form-label">Latitude:</label>
                        <MyTextInput
                          type="number"
                          name="latitude_manually"
                          className="form-textarea"
                          placeholder="Enter latitude"
                        />
                      </div>
                      <div className="form-group">
                        <label className="form-label">Longitude:</label>
                        <MyTextInput
                          type="number"
                          name="longitude_manually"
                          className="form-textarea"
                          placeholder="Enter longitude"
                        />
                      </div>
                    </div>

                    <div className="form-checkboxes" style={{ color: "#555659" }}>
                      <label className="form-label">Instructions</label>
                      <label>
                        <input
                          type="checkbox"
                          checked={isPhotos}
                          onChange={(e) => setIsPhotos(e.target.checked)}
                        />{" "}
                        {"   "}
                        isPhotos
                      </label>
                      {"   "}
                      <label>
                        <input
                          type="checkbox"
                          checked={isAudio}
                          onChange={(e) => setIsAudio(e.target.checked)}
                        />{" "}
                        {"   "}
                        isAudio
                      </label>
                      {"   "}
                      <label>
                        <input
                          type="checkbox"
                          checked={isChurch}
                          onChange={(e) => setIsChurch(e.target.checked)}
                        />{" "}
                        {"   "}
                        isChurch
                      </label>
                    </div>

                    <div className="form-row">
                      <div className="form-group">
                        <label className="form-label">Tags</label>
                        <div className="checkbox-container">
                          {" "}
                          {tagDetail.map((option) => (
                            <div key={option.id} className="checkbox-wrapper">
                              <label className="checkbox-label">
                                <input
                                  type="checkbox"
                                  value={option.id}
                                  checked={selectedTagIds.includes(option.id)}
                                  onChange={handleTagChange}
                                />
                                <span className="checkmark"></span>
                                {option.title}
                              </label>
                            </div>
                          ))}
                        </div>
                        <span style={{ color: "red" }}>{errormessageselect}</span>
                      </div>

                      <div className="form-group" style={{ marginLeft: "65px" }}>
                        <label className="form-label">Select Journey:</label>
                        <select
                          type="text"
                          className="form-select"
                          onChange={handleJourney}
                          value={Journey}
                        >
                          <option value="" disabled>
                            Select
                          </option>
                          {journeyDetail.map((journey) => (
                            <option key={journey.id} value={journey.id}>
                              {journey.title}
                            </option>
                          ))}
                        </select>

                        <span style={{ color: "red" }}>{errorjourney}</span>
                      </div>
                    </div>

                    <div className="form-row">
                      <div className="form-group">
                        <label className="form-label">
                          Estimated Time to Visit (in minutes):
                        </label>
                        <MyTextInput
                          type="number"
                          name="estimatedTimeToVisit"
                          className="form-input"
                          min="0"
                          style={{ width: "340px" }}
                          step="1"
                        />
                      </div>
                    </div>

                    <div>
                      <div>
                        <label htmlFor="galleryimageurl" className="form-label">
                          Gallery Image
                        </label>
                        <Field
                          name="galleryimageurl"
                          component={FileInput}
                          multiple
                          accept="image/*"
                        />
                        <ErrorMessage
                          name="galleryimageurl"
                          component="div"
                          className="error-message"
                        />
                      </div>
                    </div>

                    <div>
                      <div>
                        <label htmlFor="panoramicImageUrl" className="form-label">
                          360° Image
                        </label>
                        <Field
                          name="panoramicImageUrl"
                          component={FileInput}
                          multiple
                          accept="image/*"
                        />
                        <ErrorMessage
                          name="panoramicImageUrl"
                          component="div"
                          className="error-message"
                        />
                      </div>
                    </div>
                    <div>
                      <div>
                        <label
                          htmlFor="aerialViewImageUrl"
                          className="form-label"
                        >
                          Aerial Image
                        </label>
                        <Field
                          name="aerialViewImageUrl"
                          component={FileInput}
                          multiple
                          accept="image/*"
                        />
                        <ErrorMessage
                          name="aerialViewImageUrl"
                          component="div"
                          className="error-message"
                        />
                      </div>
                    </div>
                    {!getbutton ? (
                      <Button type="submit" className="form-submit">
                        Submit
                      </Button>
                    ) : (
                      <Button type="submit" className="form-submit" disabled>
                        Please Wait!!
                      </Button>
                    )}
                  </Form>
                </div>
              )}
            </Formik>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={handleClose}>
              Close
            </Button>
          </Modal.Footer>
        </Modal>

        {/* eye modal---------------------------------------------- */}
        <Modal show={showEye} onHide={handleClose1} size="lg">
          <Modal.Header closeButton>
            <Modal.Title>Places Detail</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Formik
              initialValues={{
                title: placesRowData?.row?.title
                  ? placesRowData?.row?.title
                  : "",
                title_sp: placesRowData?.row?.title_sp
                  ? placesRowData?.row?.title_sp
                  : "",
                description: placesRowData?.row?.description
                  ? placesRowData?.row?.description
                  : "",
                description_sp: placesRowData?.row?.description_sp
                  ? placesRowData?.row?.description_sp
                  : "",

                latitude_manually: placesRowData?.row?.latitude_manually
                  ? placesRowData?.row?.latitude_manually
                  : "",
                longitude_manually: placesRowData?.row?.longitude_manually
                  ? placesRowData?.row?.longitude_manually
                  : "",

                description_podcast: placesRowData?.row?.description_podcast
                  ? placesRowData?.row?.description_podcast
                  : "",
                description_podcast_sp: placesRowData?.row
                  ?.description_podcast_sp
                  ? placesRowData?.row?.description_podcast_sp
                  : "",
                estimatedTimeToVisit: placesRowData?.row?.estimatedTimeToVisit
                  ? placesRowData?.row?.estimatedTimeToVisit
                  : "",
                averageRating: placesRowData?.row?.averageRating
                  ? placesRowData?.row?.averageRating
                  : "",
              }}
              validationSchema={Yup.object({
                title: Yup.string().required("title is required"),
                title_sp: Yup.string().required("title in spanish is required"),
                description: Yup.string().required("description is required"),
                description_sp: Yup.string().required(
                  "description in spanish is required"
                ),
              })}
            >
              <div className="form-container">
                <Form>
                  <div className="form-row">
                    <div className="form-group">
                      <label className="form-label">Title:</label>
                      <MyTextInput
                        type="text"
                        name="title"
                        className="form-input"
                        readOnly
                      />
                    </div>
                    <div className="form-group">
                      <label className="form-label">Title in Spanish:</label>
                      <MyTextInput
                        type="text"
                        name="title_sp"
                        className="form-input"
                        readOnly
                      />
                    </div>
                  </div>
                  <div className="form-row">
                    <div className="form-group">
                      <label className="form-label">Description:</label>
                      <MyTextArea
                        style={{ height: "130px" }}
                        type="text"
                        name="description"
                        className="form-textarea"
                        readOnly
                      />
                    </div>
                    <div className="form-group">
                      <label className="form-label">
                        Description in Spanish:
                      </label>
                      <MyTextArea
                        style={{ height: "130px" }}
                        type="text"
                        name="description_sp"
                        className="form-textarea"
                        readOnly
                      />
                    </div>
                  </div>
                  <div className="form-row">
                    <div className="form-group">
                      <label className="form-label">Podcast Description:</label>
                      <MyTextArea
                        style={{ height: "130px" }}
                        type="text"
                        name="description_podcast"
                        className="form-textarea"
                        readOnly
                      />
                    </div>
                    <div className="form-group">
                      <label className="form-label">
                        Podcast Description in Spanish:
                      </label>
                      <MyTextArea
                        style={{ height: "130px" }}
                        type="text"
                        name="description_podcast_sp"
                        className="form-textarea"
                        readOnly
                      />
                    </div>
                  </div>
                  <div className="form-row">
                    {/* <div> */}
                    <div className="form-group">
                      <label className="form-label">Image :</label>
                      <br />
                      {placesRowData?.row?.imageurl ? (
                        <img
                          src={placesRowData?.row?.imageurl}
                          className=" w-50 p-3"
                          alt=""
                        />
                      ) : (
                        <span> No Places Found!</span>
                      )}
                    </div>

                    <div className="form-group">
                      <label className="form-label">Place location :</label>
                      <br />
                      {placesRowData?.row?.location ? (
                        <span>{placesRowData?.row?.location}</span>
                      ) : (
                        <span> No Place Found!</span>
                      )}
                    </div>
                  </div>

                  <div className="form-row">
                    <div className="form-row">
                      <div className="form-group">
                        <label className="form-label">Tags</label>
                        <div className="checkbox-container">
                          {" "}
                          {/* Container for checkboxes */}
                          {tagDetail.map((option) => (
                            <div key={option.id} className="checkbox-wrapper">
                              <label className="checkbox-label">
                                <input
                                  type="checkbox"
                                  // value={option.id}
                                  // checked={selectedTagIds.includes(option.id)}
                                  checked={placesRowData?.row?.tags.includes(
                                    option.id
                                  )}
                                  onChange={handleTagChange}
                                  readOnly
                                />
                                <span className="checkmark"></span>
                                {option.title}
                              </label>
                            </div>
                          ))}
                        </div>
                      </div>
                    </div>

                    <div className="form-checkboxes">
                      <label className="form-label">Instructions :</label>{" "}
                      {"   "}
                      <label>
                        <input
                          type="checkbox"
                          readOnly
                          checked={placesRowData?.row?.instructions?.isphotos}
                        // onChange={(e) => setIsPhotos(e.target.checked)}
                        />{" "}
                        {"   "}
                        isPhotos
                      </label>
                      {"   "}
                      <label>
                        <input
                          type="checkbox"
                          readOnly
                          checked={placesRowData?.row?.instructions?.isaudio}
                        // onChange={(e) => setIsAudio(e.target.checked)}
                        />{" "}
                        {"   "}
                        isAudio
                      </label>
                      {"   "}
                      <label>
                        <input
                          type="checkbox"
                          readOnly
                          checked={placesRowData?.row?.instructions?.ischurch}
                        // onChange={(e) => setIsChurch(e.target.checked)}
                        />{" "}
                        {"   "}
                        isChurch
                      </label>
                    </div>
                  </div>
                  <div className="form-row">
                    <div className="form-group">
                      <label className="form-label">Latitude:</label>
                      <MyTextInput
                        type="number"
                        name="latitude_manually"
                        className="form-textarea"
                        placeholder="Enter latitude"
                        readOnly
                      />
                    </div>
                    <div className="form-group">
                      <label className="form-label">Longitude:</label>
                      <MyTextInput
                        type="number"
                        name="longitude_manually"
                        className="form-textarea"
                        placeholder="Enter longitude"
                        readOnly
                      />
                    </div>
                  </div>
                  <div className="form-row">

                    <div className="form-group" >
                      <label className="form-label">Select Journey:</label>
                      <select
                        disabled
                        type="text"
                        className="form-select"
                        onChange={handleJourney}
                        value={Journey}
                      >
                        <option value="" disabled>
                          Select
                        </option>
                        {journeyDetail.map((journey) => (
                          <option key={journey.id} value={journey.id}>
                            {journey.title}
                          </option>
                        ))}
                      </select>

                      <span style={{ color: "red" }}>{errorjourney}</span>
                    </div>
                  </div>
                  <div className="form-row">
                    <div className="form-group">
                      <label className="form-label">
                        Estimated Time to Visit (in minutes):
                      </label>
                      <MyTextInput
                        type="number"
                        name="estimatedTimeToVisit"
                        className="form-input"
                        min="0"
                        style={{ width: "340px" }}
                        step="1"
                        readOnly
                      />
                    </div>
                    <div className="form-row">
                      <div className="form-group">
                        <label className="form-label">Average Rating:</label>
                        <MyTextInput
                          type="number"
                          name="averageRating"
                          className="form-input"
                          style={{ width: "340px" }}
                          readOnly
                        />
                      </div>
                    </div>
                  </div>

                  <div className="form-row">
                    {/* <div> */}
                    <div className="form-group" style={{}}>
                      <label className="form-label">Gallery Images :</label>
                      <br />
                      {placesRowData?.row?.galleryimageurl ? (
                        <div
                          style={{
                            display: "flex",
                            flexWrap: "wrap",
                            gap: "10px",
                          }}
                        >
                          {placesRowData?.row?.galleryimageurl.map((image) => (
                            <img
                              key={image.id}
                              src={image.imageUrl}
                              // className="w-100 p-3"
                              alt={`Image ${image.id}`}
                              style={{
                                width: "23%", // Adjust to fit 4 images per row with gaps
                                maxWidth: "150px", // Maximum width of each image
                                height: "auto", // Maintain aspect ratio
                              }}
                            />
                          ))}
                        </div>
                      ) : (
                        <span style={{ color: "black" }}>
                          {" "}
                          No images Found!
                        </span>
                      )}
                    </div>
                  </div>

                  <div className="form-row">
                    {/* <div> */}
                    <div className="form-group" style={{}}>
                      <label className="form-label">360° Images :</label>
                      <br />

                      {placesRowData?.row?.panoramicImageUrl ? (
                        <div
                          style={{
                            display: "flex",
                            flexWrap: "wrap",
                            gap: "10px",
                          }}
                        >
                          {placesRowData?.row?.panoramicImageUrl.map(
                            (image) => (
                              <img
                                key={image.id}
                                src={image.imageUrl}
                                // className="w-100 p-3"
                                alt={`Image ${image.id}`}
                                style={{
                                  width: "23%", // Adjust to fit 4 images per row with gaps
                                  maxWidth: "150px", // Maximum width of each image
                                  height: "auto", // Maintain aspect ratio
                                }}
                              />
                            )
                          )}
                        </div>
                      ) : (
                        <span> No images Found!</span>
                      )}
                    </div>
                  </div>

                  <div className="form-row">
                    {/* <div> */}
                    <div className="form-group" style={{}}>
                      <label className="form-label">AerialView Images :</label>
                      <br />
                      {placesRowData?.row?.aerialViewImageUrl ? (
                        <div
                          style={{
                            display: "flex",
                            flexWrap: "wrap",
                            gap: "10px",
                          }}
                        >
                          {placesRowData?.row?.aerialViewImageUrl.map(
                            (image) => (
                              <img
                                key={image.id}
                                src={image.imageUrl}
                                // className="w-100 p-3"
                                alt={`Image ${image.id}`}
                                style={{
                                  width: "23%", // Adjust to fit 4 images per row with gaps
                                  maxWidth: "150px", // Maximum width of each image
                                  height: "auto", // Maintain aspect ratio
                                }}
                              />
                            )
                          )}
                        </div>
                      ) : (
                        <span> No images Found!</span>
                      )}
                    </div>
                  </div>
                </Form>
              </div>
            </Formik>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={handleClose1}>
              Close
            </Button>
          </Modal.Footer>
        </Modal>
        {/* ----------------------------------------------------modal edit place */}

        {/* <Modal show={showEdit} onHide={handleClose3} size="lg">
          <Modal.Header closeButton>
            <Modal.Title>Edit place</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Formik
              initialValues={{
                title: placesRowData?.row?.title
                  ? placesRowData?.row?.title
                  : "",
                title_sp: placesRowData?.row?.title_sp
                  ? placesRowData?.row?.title_sp
                  : "",
                description: placesRowData?.row?.description
                  ? placesRowData?.row?.description
                  : "",
                description_sp: placesRowData?.row?.description_sp
                  ? placesRowData?.row?.description_sp
                  : "",
                imageurl: null,
                galleryimageurl: [],
              }}
              validationSchema={Yup.object({
                title: Yup.string().required("title is required"),
                title_sp: Yup.string().required("title in spanish is required"),
                description: Yup.string().required("description is required"),
                description_sp: Yup.string().required(
                  "description in spanish is required"
                ),
                imageurl: Yup.mixed().nullable(),
                galleryimageurl: Yup.array().nullable().of(Yup.mixed()),
              })}
              onSubmit={(values, { resetForm }) => {
                let formData = new FormData();
                formData.append("title", values.title);
                formData.append("title_sp", values.title_sp);
                formData.append("description", values.description);
                formData.append("description_sp", values.description_sp);

                if (values.imageurl && values.imageurl.length > 0) {
                  formData.append("imageurl", values.imageurl[0]);
                }

                if (
                  Array.isArray(values.galleryimageurl) &&
                  values.galleryimageurl.length > 0
                ) {
                  values.galleryimageurl.forEach((file, index) => {
                    formData.append(`galleryimageurl`, file);
                  });
                }

                if (address) {
                  formData.append("location", address);

                  // Append latitude and longitude only if latLng is defined
                  if (latLng && latLng.lat && latLng.lng) {
                    formData.append("latitude", latLng.lat);
                    formData.append("longitude", latLng.lng);
                  }
                }

                selectedTagIds.forEach((tagId, index) => {
                  formData.append(`tags[${index}]`, tagId);
                });

                formData.append("isphotos", isPhotos);
                formData.append("isaudio", isAudio);
                formData.append("ischurch", isChurch);

                setbutton(true);
                update_place_byId(updatePlaceId, formData)
                  .then((res) => {
                    Store.addNotification({
                      title: "Success",
                      message: res?.data?.message,
                      type: "success",
                      insert: "top",
                      container: "top-right",
                      animationIn: ["animate__animated", "animate__fadeIn"],
                      animationOut: ["animate__animated", "animate__fadeOut"],
                      dismiss: {
                        duration: 3000,
                        onScreen: true,
                      },
                    });
                    resetForm({ formData: "" });

                    get_journey_data(placesRowData?.row?.journeyId)
                      .then((res) => {
                        // setUserDetail(res.data.user);
                        const places = Array.isArray(res?.data?.data) ? res.data.data : [];
                        setJourneyDataById(
                          places.map((el, index) => ({
                            ...el,
                            id: el.id,
                            i: index,
                          }))
                        );
                      })

                      .catch((err) => {
                        console.log(err);
                      });

                    handleClose3();
                    setbutton(false);
                  })
                  .catch((err) => {
                    console.log(err);
                    if (err) {
                      Store.addNotification({
                        title: "Error!",
                        message: err?.response?.data?.message,
                        type: "danger",
                        insert: "top",
                        container: "top-right",
                        animationIn: ["animate__animated", "animate__fadeIn"],
                        animationOut: ["animate__animated", "animate__fadeOut"],
                        dismiss: {
                          duration: 3000,
                          onScreen: true,
                        },
                      });
                      setbutton(false);
                    }
                  });
              }}
            >
              <div className="form-container">
                <Form>
                  <div className="form-row">
                    <div className="form-group">
                      <label className="form-label">Title:</label>
                      <MyTextInput
                        type="text"
                        name="title"
                        className="form-input"
                      />
                    </div>
                    <div className="form-group">
                      <label className="form-label">Title in Spanish:</label>
                      <MyTextInput
                        type="text"
                        name="title_sp"
                        className="form-input"
                      />
                    </div>
                  </div>
                  <div className="form-row">
                    <div className="form-group">
                      <label className="form-label">Description:</label>
                      <MyTextArea
                        type="text"
                        name="description"
                        style={{ height: "130px" }}
                        className="form-textarea"
                      />
                    </div>
                    <div className="form-group">
                      <label className="form-label">
                        Description in Spanish:
                      </label>
                      <MyTextArea
                        type="text"
                        name="description_sp"
                        style={{ height: "130px" }}
                        className="form-textarea"
                      />
                    </div>
                  </div>
                  <div className="form-row">
                    <div className="form-group">
                      {placesRowData?.row?.imageurl ? (
                        <img
                          src={placesRowData?.row?.imageurl}
                          className=" w-50 p-3"
                          alt=""
                        />
                      ) : (
                        <span> No Places Found!</span>
                      )}
                      <label htmlFor="imageurl" className="form-label">
                        Banner Image
                      </label>
                      <Field name="imageurl" component={FileInput} />
                      <ErrorMessage name="imageurl" component="div" />
                    </div>

                    <div className="form-group">
                      <div>
                        {placesRowData?.row?.location ? (
                          <span>{placesRowData?.row?.location}</span>
                        ) : (
                          <span> No Place Found!</span>
                        )}
                      </div>
                      <label className="form-label">Address:</label>

                      <GooglePlacesAutocomplete
                        apiKey="AIzaSyAZayBd_1QMbIZpRgTc9-QDvtrmuA-w-xI"
                        onSelect={handleSelectAddress}
                        renderInput={(props) => (
                          <input
                            {...props}
                            className="form-control"
                            // required
                          ></input>
                        )}
                      />
                    </div>
                  </div>
                  <div className="form-row">
                    <div className="form-checkboxes">
                      Instructions: {"   "}
                      <label>
                        <input
                          type="checkbox"
                          checked={isPhotos}
                          onChange={(e) => setIsPhotos(e.target.checked)}
                        />{" "}
                        {"   "}
                        isPhotos
                      </label>
                      {"   "}
                      <label>
                        <input
                          type="checkbox"
                          checked={isAudio}
                          onChange={(e) => setIsAudio(e.target.checked)}
                        />{" "}
                        {"   "}
                        isAudio
                      </label>
                      {"   "}
                      <label>
                        <input
                          type="checkbox"
                          checked={isChurch}
                          onChange={(e) => setIsChurch(e.target.checked)}
                        />{" "}
                        {"   "}
                        isChurch
                      </label>
                    </div>

                    <div className="form-row">
                      <div className="form-group">
                        <label className="form-label">Tags</label>
                        <div className="checkbox-container">
                          {" "}
                          {tagDetail.map((option) => (
                            <div key={option.id} className="checkbox-wrapper">
                              <label className="checkbox-label">
                                <input
                                  type="checkbox"
                                  value={option.id}
                                  checked={selectedTagIds.includes(option.id)}
                                  onChange={handleTagChange}
                                />
                                <span className="checkmark"></span>
                                {option.title}
                              </label>
                            </div>
                          ))}
                        </div>
                      </div>
                    </div>
                  </div>

             
                  <div>
                    <label htmlFor="galleryimageurl" className="form-label">
                      Gallery Image
                    </label>
                    <Field
                      name="galleryimageurl"
                      component={FileInput}
                      multiple
                    />
                    <ErrorMessage name="galleryimageurl" component="div" />
                  </div>
                  {!getbutton ? (
                    <Button type="submit" className="form-submit">
                      Submit
                    </Button>
                  ) : (
                    <Button type="submit" className="form-submit" disabled>
                      Please Wait!!
                    </Button>
                  )}
                </Form>
              </div>
            </Formik>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={handleClose3}>
              Close
            </Button>
          </Modal.Footer>
        </Modal> */}
        {/* )))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))) */}
        <Modal show={showEdit} onHide={handleClose3} size="lg">
          <Modal.Header closeButton>
            <Modal.Title>Edit place</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Formik
              initialValues={{
                title: placesRowData?.row?.title
                  ? placesRowData?.row?.title
                  : "",
                title_sp: placesRowData?.row?.title_sp
                  ? placesRowData?.row?.title_sp
                  : "",
                description: placesRowData?.row?.description
                  ? placesRowData?.row?.description
                  : "",
                description_sp: placesRowData?.row?.description_sp
                  ? placesRowData?.row?.description_sp
                  : "",
                description_podcast: placesRowData?.row?.description_podcast
                  ? placesRowData?.row?.description_podcast
                  : "",
                latitude_manually: placesRowData?.row?.latitude_manually
                  ? placesRowData?.row?.latitude_manually
                  : "",
                longitude_manually: placesRowData?.row?.longitude_manually
                  ? placesRowData?.row?.longitude_manually
                  : "",
                description_podcast_sp: placesRowData?.row
                  ?.description_podcast_sp
                  ? placesRowData?.row?.description_podcast_sp
                  : "",
                estimatedTimeToVisit: placesRowData?.row?.estimatedTimeToVisit
                  ? placesRowData?.row?.estimatedTimeToVisit
                  : "",
                imageurl: null,
                galleryimageurl: [],
                panoramicImageUrl: [],
                aerialViewImageUrl: [],
              }}
              validationSchema={Yup.object({
                title: Yup.string()
                  .required("Title is required")
                  .min(3, "Title must be at least 3 characters")
                  .max(50, "Title cannot exceed 50 characters"),

                title_sp: Yup.string()
                  .required("Title in Spanish is required")
                  .min(3, "Title must be at least 3 characters")
                  .max(50, "Title cannot exceed 50 characters"),
                description: Yup.string()
                  .required("Please Enter Description")
                  .min(10, "Description must be at least 10 characters"),

                description_sp: Yup.string()
                  .required("Please Enter Description in Spanish")
                  .min(10, "Description must be at least 10 characters"),
                latitude_manually: Yup.string(),
                longitude_manually: Yup.string(),
                description_podcast: Yup.string()
                  .required("Description for podcast is required")
                  .min(10, "Description must be at least 10 characters"),

                description_podcast_sp: Yup.string()
                  .required("Description for podcast in Spanish is required")
                  .min(10, "Description must be at least 10 characters"),
                imageurl: Yup.mixed().nullable(),
                galleryimageurl: Yup.array().nullable().of(Yup.mixed()),
                panoramicImageUrl: Yup.array().nullable().of(Yup.mixed()),
                aerialViewImageUrl: Yup.array().nullable().of(Yup.mixed()),
                estimatedTimeToVisit: Yup.number()
                  .positive("Time must be a positive number")
                  .integer("Time must be an integer")
                  .required("Please enter estimated time"),
              })}

              onSubmit={(values, { resetForm }) => {


                let formData = new FormData();
                formData.append("title", values.title);
                formData.append("title_sp", values.title_sp);
                formData.append("description", values.description);
                formData.append("description_sp", values.description_sp);
                formData.append("journeyId", Journey);
                formData.append(
                  "description_podcast",
                  values.description_podcast
                );
                formData.append(
                  "description_podcast_sp",
                  values.description_podcast_sp
                );
                formData.append("latitude_manually", values.latitude_manually);
                formData.append(
                  "longitude_manually",
                  values.longitude_manually
                );

                if (values.estimatedTimeToVisit) {
                  formData.append(
                    "estimatedTimeToVisit",
                    values.estimatedTimeToVisit
                  );
                }

                if (values.imageurl && values.imageurl.length > 0) {
                  formData.append("imageurl", values.imageurl[0]);
                }

                if (
                  Array.isArray(values.galleryimageurl) &&
                  values.galleryimageurl.length > 0
                ) {
                  values.galleryimageurl.forEach((file, index) => {
                    formData.append(`galleryimageurl`, file);
                  });
                }

                if (
                  Array.isArray(values.panoramicImageUrl) &&
                  values.panoramicImageUrl.length > 0
                ) {
                  values.panoramicImageUrl.forEach((file, index) => {
                    formData.append(`panoramicImageUrl`, file);
                  });
                }

                if (
                  Array.isArray(values.aerialViewImageUrl) &&
                  values.aerialViewImageUrl.length > 0
                ) {
                  values.aerialViewImageUrl.forEach((file, index) => {
                    formData.append(`aerialViewImageUrl`, file);
                  });
                }

                if (address) {
                  formData.append("location", address);

                  // Append latitude and longitude only if latLng is defined
                  if (latLng && latLng.lat && latLng.lng) {
                    formData.append("latitude", latLng.lat);
                    formData.append("longitude", latLng.lng);
                  }
                }

                selectedTagIds.forEach((tagId, index) => {
                  formData.append(`tags[${index}]`, tagId);
                });

                formData.append("isphotos", isPhotos);
                formData.append("isaudio", isAudio);
                formData.append("ischurch", isChurch);

                setbutton(true);
                update_place_byId(updatePlaceId, formData)
                  .then((res) => {
                    Store.addNotification({
                      title: "Success",
                      message: res?.data?.message,
                      type: "success",
                      insert: "top",
                      container: "top-right",
                      animationIn: ["animate__animated", "animate__fadeIn"],
                      animationOut: ["animate__animated", "animate__fadeOut"],
                      dismiss: {
                        duration: 3000,
                        onScreen: true,
                      },
                    });
                    resetForm({ formData: "" });

                    get_journey_data(placesRowData?.row?.journeyId)
                      .then((res) => {
                        // setUserDetail(res.data.user);
                        const places = Array.isArray(res?.data?.data) ? res.data.data : [];
                        setJourneyDataById(
                          places.map((el, index) => ({
                            ...el,
                            id: el._id,
                            i: index,
                          }))
                        );
                      })

                      .catch((err) => {
                        console.log(err);
                      });
                    getAllPlaces()
                      .then((res) => {
                        const places = Array.isArray(res?.data?.data) ? res.data.data : [];
                        setAllPlaces(places);
                      })
                      .catch((err) => {
                        console.log(err);
                      });

                    handleClose3();
                    setbutton(false);
                  })
                  .catch((err) => {
                    console.log(err);
                    if (err) {
                      Store.addNotification({
                        title: "Error!",
                        message: err?.response?.data?.message,
                        type: "danger",
                        insert: "top",
                        container: "top-right",
                        animationIn: ["animate__animated", "animate__fadeIn"],
                        animationOut: ["animate__animated", "animate__fadeOut"],
                        dismiss: {
                          duration: 3000,
                          onScreen: true,
                        },
                      });
                      setbutton(false);
                    }
                  });
              }}
            >
              {({ setFieldValue }) => (
                <div className="form-container">
                  <Form>
                    <div className="form-row">
                      <div className="form-group">
                        <label className="form-label">Title:</label>
                        <MyTextInput
                          type="text"
                          name="title"
                          className="form-input"
                        />
                      </div>
                      <div className="form-group">
                        <label className="form-label">Title in Spanish:</label>
                        <MyTextInput
                          type="text"
                          name="title_sp"
                          className="form-input"
                        />
                      </div>
                    </div>
                    <div className="form-row">
                      <div className="form-group">
                        <label className="form-label">Description:</label>
                        <MyTextArea
                          type="text"
                          name="description"
                          style={{ height: "130px" }}
                          className="form-textarea"
                        />
                      </div>
                      <div className="form-group">
                        <label className="form-label">
                          Description in Spanish:
                        </label>
                        <MyTextArea
                          type="text"
                          name="description_sp"
                          style={{ height: "130px" }}
                          className="form-textarea"
                        />
                      </div>
                    </div>
                    <div className="form-row">
                      <div className="form-group">
                        <label className="form-label">Podcast Description:</label>
                        <MyTextArea
                          type="text"
                          name="description_podcast"
                          style={{ height: "130px" }}
                          className="form-textarea"
                        />
                      </div>
                      <div className="form-group">
                        <label className="form-label">
                          Podcast Description in Spanish:
                        </label>
                        <MyTextArea
                          type="text"
                          name="description_podcast_sp"
                          style={{ height: "130px" }}
                          className="form-textarea"
                        />
                      </div>
                    </div>
                    <div className="form-row">
                      <div className="form-group">
                        {placesRowData?.row?.imageurl ? (
                          <img
                            src={placesRowData?.row?.imageurl}
                            className="w-50 p-3"
                            alt=""
                          />
                        ) : (
                          <span> No Places Found!</span>
                        )}
                        <label htmlFor="imageurl" className="form-label">
                          Banner Image
                        </label>
                        <Field name="imageurl" component={FileInput} />
                        <ErrorMessage name="imageurl" component="div" />
                      </div>

                      {/* <div className="form-group">
                        <div style={{ cursor: 'pointer' }}>
                          {placesRowData?.row?.location ? (
                            <span style={{ cursor: 'pointer' }}>{placesRowData?.row?.location}</span>
                          ) : (
                            <span> No Place Found!</span>
                          )}
                        </div>
                        <label className="form-label">Address:</label>

                        <GooglePlacesAutocomplete
                          style={{ cursor: 'pointer' }}
                          apiKey="AIzaSyC82fZSJymdGrJnap27r0enC7nQahR3E8Q"
                          onSelect={(item) => handleSelectAddress(item, setFieldValue)}
                          renderInput={(props) => (
                            <input
                              {...props}
                              className="form-control"
                            // required
                            ></input>
                          )}
                        />
                      </div> */}
                    </div>
                    <div>
                      <div className="form-group" style={{ overflow: 'hidden' }}>
                        <label>Select Location on Map</label>
                        <GoogleMapSelectorEdit latLng={latLng} setLatLng={setLatLng} setAddress={setAddress} setFieldValue={setFieldValue} />
                      </div>
                    </div>
                    <div className="form-row">
                      <div className="form-group">
                        <label className="form-label">Latitude:</label>
                        <MyTextInput
                          type="number"
                          name="latitude_manually"
                          className="form-textarea"
                          placeholder="Enter latitude"
                        />
                      </div>
                      <div className="form-group">
                        <label className="form-label">Longitude:</label>
                        <MyTextInput
                          type="number"
                          name="longitude_manually"
                          className="form-textarea"
                          placeholder="Enter longitude"
                        />
                      </div>
                    </div>
                    <div className="form-row">
                      <div className="form-checkboxes">
                        Instructions: {"   "}
                        <label>
                          <input
                            type="checkbox"
                            checked={isPhotos}
                            onChange={(e) => setIsPhotos(e.target.checked)}
                          />{" "}
                          {"   "}
                          isPhotos
                        </label>
                        {"   "}
                        <label>
                          <input
                            type="checkbox"
                            checked={isAudio}
                            onChange={(e) => setIsAudio(e.target.checked)}
                          />{" "}
                          {"   "}
                          isAudio
                        </label>
                        {"   "}
                        <label>
                          <input
                            type="checkbox"
                            checked={isChurch}
                            onChange={(e) => setIsChurch(e.target.checked)}
                          />{" "}
                          {"   "}
                          isChurch
                        </label>
                      </div>

                      <div className="form-row">
                        <div className="form-group">
                          <label className="form-label">Tags</label>
                          <div className="checkbox-container">
                            {" "}
                            {tagDetail.map((option) => (
                              <div key={option.id} className="checkbox-wrapper">
                                <label className="checkbox-label">
                                  <input
                                    type="checkbox"
                                    value={option.id}
                                    checked={selectedTagIds.includes(option.id)}
                                    onChange={handleTagChange}
                                  />
                                  <span className="checkmark"></span>
                                  {option.title}
                                </label>
                              </div>
                            ))}
                          </div>
                        </div>


                      </div>

                    </div>
                    <div className="form-row">

                      <div className="form-group" >
                        <label className="form-label">Select Journey:</label>
                        <select
                          type="text"
                          className="form-select"
                          onChange={handleJourney}
                          value={Journey}
                        >
                          <option value="" disabled>
                            Select
                          </option>
                          {journeyDetail.map((journey) => (
                            <option key={journey.id} value={journey.id}>
                              {journey.title}
                            </option>
                          ))}
                        </select>

                        <span style={{ color: "red" }}>{errorjourney}</span>
                      </div>
                    </div>
                    <div className="form-row">
                      <div className="form-group">
                        <label className="form-label">
                          Estimated Time to Visit (in minutes):
                        </label>
                        <MyTextInput
                          type="number"
                          name="estimatedTimeToVisit"
                          className="form-input"
                          min="0"
                          style={{ width: "340px" }}
                          step="1"
                        />
                      </div>
                    </div>

                    <div>
                      <label htmlFor="galleryimageurl" className="form-label">
                        Gallery Image
                      </label>
                      <Field
                        name="galleryimageurl"
                        component={FileInput}
                        multiple
                        accept="image/*"
                      />
                      <ErrorMessage name="galleryimageurl" component="div" />
                    </div>

                    <div>
                      <label htmlFor="panoramicImageUrl" className="form-label">
                        360° Image
                      </label>
                      <Field
                        name="panoramicImageUrl"
                        component={FileInput}
                        multiple
                        accept="image/*"
                      />
                      <ErrorMessage name="panoramicImageUrl" component="div" />
                    </div>

                    <div>
                      <label htmlFor="aerialViewImageUrl" className="form-label">
                        Aerial Image
                      </label>
                      <Field
                        name="aerialViewImageUrl"
                        component={FileInput}
                        multiple
                        accept="image/*"
                      />
                      <ErrorMessage name="aerialViewImageUrl" component="div" />
                    </div>
                    {!getbutton ? (
                      <Button type="submit" className="form-submit">
                        Update
                      </Button>
                    ) : (
                      <Button type="submit" className="form-submit" disabled>
                        Please Wait!!
                      </Button>
                    )}
                  </Form>
                </div>
              )}
            </Formik>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={handleClose3}>
              Close
            </Button>
          </Modal.Footer>
        </Modal>

        {/* ------------------------------ */}

        <Modal show={showImages} onHide={handleClose4} size="lg">
          <Modal.Header closeButton>
            <Modal.Title>Images</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {/* jorurneyDatabyId */}
            <div className="form-row">
              <div className="form-group">
                <label className="form-label">Gallery Images:</label>
                <br />
                {galleryImage?.row?.galleryimageurl ? (
                  <div
                    style={{
                      display: "flex",
                      flexWrap: "wrap",
                      gap: "10px",
                    }}
                  >
                    {galleryImage.row.galleryimageurl.map((image) => (
                      <div
                        key={image._id}
                        style={{
                          position: "relative",
                          width: "calc(33.333% - 10px)",
                          maxWidth: "500px",
                          height: "auto",
                        }}
                      >
                        <img
                          src={image.imageUrl}
                          alt={`Image ${image._id}`}
                          style={{
                            width: "100%",
                            height: "auto",
                          }}
                        />
                        <button
                          onClick={() =>
                            onDeleteImage(image._id || image.id, "gallery")
                          }
                          style={{
                            position: "absolute",
                            top: "5px",
                            right: "5px",
                            background: "transparent",
                            border: "none",
                            cursor: "pointer",
                            fontSize: "18px",
                            color: "red",
                            zIndex: "10",
                          }}
                        >
                          ❌
                        </button>
                      </div>
                    ))}
                  </div>
                ) : (
                  <span>No images found!</span>
                )}
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label className="form-label">360° Images: </label>
                <br />
                {galleryImage?.row?.panoramicImageUrl ? (
                  <div
                    style={{
                      display: "flex",
                      flexWrap: "wrap",
                      gap: "10px",
                    }}
                  >
                    {galleryImage?.row?.panoramicImageUrl?.map((image) => (
                      <div
                        key={image._id}
                        style={{
                          position: "relative",
                          width: "calc(33.333% - 10px)",
                          maxWidth: "500px",
                          height: "auto",
                        }}
                      >
                        <img
                          src={image.imageUrl}
                          alt={`Image ${image._id}`}
                          style={{
                            width: "100%",
                            height: "auto",
                          }}
                        />
                        <button
                          onClick={() =>
                            onDeleteImage(image._id || image.id, "pano")
                          }
                          style={{
                            position: "absolute",
                            top: "5px",
                            right: "5px",
                            background: "transparent",
                            border: "none",
                            cursor: "pointer",
                            fontSize: "18px",
                            color: "red",
                            zIndex: "10",
                          }}
                        >
                          ❌
                        </button>
                      </div>
                    ))}
                  </div>
                ) : (
                  <span>No images found!</span>
                )}
              </div>
            </div>
            <div className="form-row">
              <div className="form-group">
                <label className="form-label">AerialView Images:</label>
                <br />
                {galleryImage?.row?.aerialViewImageUrl ? (
                  <div
                    style={{
                      display: "flex",
                      flexWrap: "wrap",
                      gap: "10px",
                    }}
                  >
                    {galleryImage.row.aerialViewImageUrl.map((image) => (
                      <div
                        key={image._id}
                        style={{
                          position: "relative",
                          width: "calc(33.333% - 10px)",
                          maxWidth: "500px",
                          height: "auto",
                        }}
                      >
                        <img
                          src={image.imageUrl}
                          alt={`Image ${image._id}`}
                          style={{
                            width: "100%",
                            height: "auto",
                          }}
                        />
                        <button
                          onClick={() =>
                            onDeleteImage(image._id || image.id, "aerialview")
                          }
                          style={{
                            position: "absolute",
                            top: "5px",
                            right: "5px",
                            background: "transparent",
                            border: "none",
                            cursor: "pointer",
                            fontSize: "18px",
                            color: "red",
                            zIndex: "10",
                          }}
                        >
                          ❌
                        </button>
                      </div>
                    ))}
                  </div>
                ) : (
                  <span>No images found!</span>
                )}
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={handleClose4}>
              Close
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
    </>
  );
}

export default PlacesManagements;
